import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { ProperJsonDialogComponent } from "../properJsonDialog/properjsondialog.component";
import { TableUtil } from "../admintrademaster/tableUtil";

@Component({
  selector: "app-payout-summary",
  templateUrl: "./payout-summary.component.html",
  styleUrls: ["./payout-summary.component.css"],
})
export class PayoutSummaryComponent implements OnInit {
  _csrf: string;
  request_id: string = "";

  private gridApi: GridApi;
  //private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };

  summary: any = [];
  oSummary: any = [];
  searchValue: string = "";
  userList: any[] = [];
  filteredUserList: any[] = [];
  userSearchValue: string = "";
  isUserSelectOpen: boolean = false;
  filter: any = {
    page: 1,
    limit: 100,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    userId: "", // Default to all users
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => true;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadUserList() {
    if (!this._csrf) {
      console.warn('CSRF token not available, cannot load user list');
      return;
    }

    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: '',
      status: 'Active'
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.userList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.userList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.userList = response.data;
        } else if (response && response.status && response.customers) {
          this.userList = response.customers || [];
        } else {
          this.userList = [];
          console.warn('Unexpected response format:', response);
        }
        this.filteredUserList = this.userList;
      },
      (error) => {
        console.error('Error loading user list:', error);
        this.userList = [];
        this.filteredUserList = [];
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: "Action",
        field: "action",
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement("div");
          container.style.display = "flex";
          container.style.alignItems = "center";

          const viewBtn = document.createElement("button");
          viewBtn.type = "button";
          viewBtn.className = "btn btn-sm btn-info";
          viewBtn.title = "View";
          viewBtn.style.marginRight = "5px";
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, "Payout Topup");
          };
          container.appendChild(viewBtn);
          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 70,
      },
      {
        headerName: "User",
        field: "UserId.name",
        valueGetter: (params) => {
          if (params.data && params.data.UserId && params.data.UserId.name) {
            return params.data.UserId.name;
          }
          return "";
        },
        flex: 1,
      },
      {
        headerName: "Date", field: "SummaryDate", flex: 1,
        valueFormatter: (params) => {
          if (!params.value) return "";
          return new Date(params.value).toLocaleDateString();
        },
      },
      { headerName: "PayoutAmount", field: "PayoutAmount", flex: 1 },
      { headerName: "AvgRate", field: "AvgRate", flex: 1 },
      { headerName: "Crypto To Settle", field: "CryptoAmount", flex: 1 },
      { headerName: "Crypto Settled", field: "ReceivedCryptoAmount", flex: 1 },
      { headerName: "Net Today Settled", field: "NetTodayCryptoAmount", flex: 1 },
      { headerName: "Net Settled", field: "PendingToSettle", flex: 1 },
      { headerName: "Crypto Currency", field: "CryptoCurrency", flex: 1 },
      { headerName: "Payout Currency", field: "PayoutCurrency", flex: 1 },
      { headerName: "OrderCount", field: "OrderCount", flex: 1 },
      { headerName: "SettleCount", field: "SettleCount", flex: 1 },
      {
        headerName: "CreatedAt",
        field: "createdAt",
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format("MMM DD, YYYY hh:mm:ss A");
          }
          return "";
        },
        flex: 1.5,
      },
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    //this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadUserList();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: any, type: Number = 1) {
    if (event.value) {
      if (type == 1) {
        this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
      }
    }
  }

  toDateFilter(event: any) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || "";
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }
    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = "";
    this.applyFilter("");
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      const search = searchValue.toLowerCase();
      this.summary = this.oSummary.filter((x: any) => {
        return (
          (x.TxnId && x.TxnId.toLowerCase().includes(search)) ||
          (x.Currency && x.Currency.toLowerCase().includes(search)) ||
          (x.PaymentMethod && x.PaymentMethod.toLowerCase().includes(search)) ||
          (x.Note && x.Note.toLowerCase().includes(search)) ||
          (x.UserId && x.UserId.name && x.UserId.name.toLowerCase().includes(search))
        );
      });
    } else {
      this.summary = this.oSummary;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getAllPayoutSettlementSummary(this.filter).subscribe((list: any) => {
      this.summary = list;
      this.oSummary = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter("");
          this.summary = this.oSummary;
        }
      }

      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      } else {
        this.next_disabled = false;
      }
    });
  }

  exportArray() {
    this.spinnerService.show();

    // Fetch fresh with a large limit (ignoring current page) so the export isn't capped to one page
    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      userId: this.filter.userId || '',
      page: 1,
      limit: 5000,
    };

    this.userService.getAllPayoutSettlementSummary(exportFilter).subscribe(
      (list: any) => {
        if (list && list.length > 0) {
          const exportData = list.map((x: any) => ({
            ...x,
            UserId: x.UserId ? x.UserId._id : '',
            UserName: x.UserId ? x.UserId.name : '',
          }));
          TableUtil.exportArrayToExcel(exportData, 'PayoutSummary');
        } else {
          this.notifSer.info("Info", "No data available to export", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.notifSer.error("Error", "Failed to export data. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.spinnerService.hide();
      }
    );
  }

  displayProperJson(jsonData, eventType) {
    const obj = {
      jsonData: jsonData,
      eventType: eventType || "Payout Topup",
    };
    this.dialog
      .open(ProperJsonDialogComponent, {
        width: "auto",
        height: "auto",
        data: obj,
      })
      .afterClosed()
      .subscribe(() => { });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      userId: "",
    };
    this.searchValue = "";
    if (this.gridApi) {
      this.gridApi.setQuickFilter("");
    }
    this.summary = this.oSummary;
    this.getData();
  }

  onUserSelectOpened(isOpen: boolean) {
    this.isUserSelectOpen = isOpen;
    if (isOpen) {
      this.userSearchValue = '';
      this.filteredUserList = this.userList;
      setTimeout(() => {
        this.addSearchToSelectPanel();
      }, 150);
    } else {
      this.userSearchValue = '';
      this.filteredUserList = this.userList;
    }
  }

  addSearchToSelectPanel() {
    const panel = document.querySelector('.user-select-panel');
    if (panel) {
      const existingSearch = panel.querySelector('.user-search-container');
      if (existingSearch) {
        existingSearch.remove();
      }

      const searchContainer = document.createElement('div');
      searchContainer.className = 'user-search-container';
      searchContainer.innerHTML = `
        <input
          type="text"
          placeholder="Search user..."
          class="user-search-input"
          value="${this.userSearchValue || ''}">
      `;

      const searchInput = searchContainer.querySelector('.user-search-input') as HTMLInputElement;
      if (searchInput) {
        searchInput.addEventListener('input', (e: any) => {
          this.userSearchValue = e.target.value;
          this.filterUsers(e);
        });
        searchInput.addEventListener('click', (e: any) => {
          e.stopPropagation();
        });
        searchInput.addEventListener('keydown', (e: any) => {
          e.stopPropagation();
        });
      }

      if (panel.firstChild) {
        panel.insertBefore(searchContainer, panel.firstChild);
      } else {
        panel.appendChild(searchContainer);
      }

      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    }
  }

  filterUsers(event: any) {
    const searchTerm = event ? (event.target ? event.target.value : event) : this.userSearchValue;
    this.userSearchValue = searchTerm || '';

    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredUserList = this.userList;
      return;
    }

    const term = searchTerm.toLowerCase();
    this.filteredUserList = this.userList.filter(user => {
      const name = (user.name || '').toLowerCase();
      const email = (user.email || '').toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-Summary/payout-summary.component.ts